import { render, staticRenderFns } from "./availability-chart.vue?vue&type=template&id=72538766&scoped=true"
import script from "./availability-chart.vue?vue&type=script&lang=js"
export * from "./availability-chart.vue?vue&type=script&lang=js"
import style0 from "./availability-chart.vue?vue&type=style&index=0&id=72538766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72538766",
  null
  
)

export default component.exports